export const SalesForceDetailedFeatures = [
    {
        "tab_heading":"CRM / Lead Management",
        "tab_info":[
            {
                "name":"Lead Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"1-click Property portals integration - auto lead capture",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Configurable Pipeline Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Custom Fields",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Team Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Full Hierarchy Management",
                "realtor":"Yes",
                "type":"Yes"
            }
        ]
    },
    {
        "tab_heading":"Cost Effective Salesforce Alternative",
        "total_savings":"INR 6 Lakhs+ & 2000+ Sales Hours",
        "notes":"Note : * Data acquired from internal research done on an existing user.",
        "tab_info":[
            {
                "name":"License Cost(Sales User)",
                "realtor":"2,599 pm",
                "type":"1,750 pm"
            },
            {
                "name":"License Cost(Marketing Automation)",
                "realtor":"5,999 pm",
                "type":"185,000 pm"
            },
            {
                "name":"Customization",
                "realtor":"0",
                "type":"400,000+*"
            },
            {
                "name":"Cost of Implementation",
                "realtor":"35000 (one time cost)",
                "type":"100,000+* (one time cost)"
            },
            {
                "name":"Support",
                "realtor":"Free",
                "type":"Extra charges"
            },
            {
                "name":"Total Cost of Ownership",
                "realtor":"134,563",
                "type":"748,000*"
            },
            {
                "name":"Total Implementation Time",
                "realtor":"72 Hours",
                "type":"90 Days"
            }
        ]
    }
];
export default SalesForceDetailedFeatures;
